<template>

  <nav class="main-nav" role="navigation" aria-label="main navigation">
    <div class="container is-fluid">
      <div class="level is-mobile">
        <div class="level-left">
          <div class="brand">
            <a class="item logo" href="/">
              <img src="../../../static/logo/cvjm-color.svg" class="normal">
              <img src="../../../static/logo/cvjm-black.svg" class="fixed">
            </a>
          </div>
        </div>

        <div class="desktop-menu level-item">
          <div class="menu">
            <template v-for="(item, index) in menu">
              <div class="item dropdown is-hoverable" v-if="item.links.length > 0">
                <div class="dropdown-trigger">
                  <a :href="item.url.path" :class="'nav-link ' + isActive(item.url.path)">
                    {{ item.label }}
                  </a>
                </div>
                <div class="dropdown-menu">
                  <div class="dropdown-content">
                    <template v-for="(dropdown_item, dropdown_index) in item.links">
                      <a :href="dropdown_item.url.path" :class="'nav-link ' + isActive(dropdown_item.url.path)">{{ dropdown_item.label }}</a>
                    </template>
                  </div>
                </div>
              </div>
              <a class="item" v-else :href="item.url.path" :class="'nav-link ' + isActive(item.url.path)">
                {{ item.label }}
              </a>
            </template>
          </div>
        </div>

        <div class="burger-menu">
            <template v-for="(item, index) in menu">
              <div class="item" v-if="item.links.length > 0">
                  <a :href="item.url.path" :class="'nav-link ' + isActive(item.url.path)">
                    {{ item.label }}
                  </a>
                <div class="sub">
                  <template v-for="(dropdown_item, dropdown_index) in item.links">
                    <a :href="dropdown_item.url.path" :class="'item ' + isActive(dropdown_item.url.path)">{{ dropdown_item.label }}</a>
                  </template>
                </div>
              </div>
              <a class="item" v-else :href="item.url.path" :class="'nav-link ' + isActive(item.url.path)">
                {{ item.label }}
              </a>
            </template>
        </div>

        <div class="level-right is-mobile">
          <a href="#" class="menu-button" id="menuButton">
              <span class="burger-icon"></span>
          </a>
        </div>
      </div>
    </div>
  </nav>

</template>
<script>

  export default {
    props: {
      menu: {},
    },
    mounted() {

      var menuButton = document.getElementById('menuButton');
        menuButton.addEventListener('click', function (e) {
        menuButton.classList.toggle('is-active');
        $(".burger-menu").toggleClass("is-active");
        e.preventDefault();
      });

      var mainNavigation = $(".main-nav");
      var scrollTop = 0;

      $(window).scroll(function () {
        console.log(scrollTop);
        if ($(document).scrollTop() > 50) {
          mainNavigation.addClass('is-fixed-top-active');
          //mainNavigation.addClass('is-light');
        } else {
          mainNavigation.removeClass('is-fixed-top-active');
          //mainNavigation.removeClass('is-light');
        }
      });



    },
    methods: {
      isActive: function(link) {
        if(window.location.pathname === link) {
          return 'is-active';
         }
        else return '';
      },
      getIcon: function(value) {
        if(value == "Wir") return "portrait";
        else if (value == "Gruppen") return "play";
        else if (value == "Musik") return "music";
        else if (value == "Freizeiten") return "mountain";
        else if (value == "Events") return "calendar";
        else if (value == "Kontakt") return "paper-plane";
        else return "hand-point-right"
      },
    },
  }
</script>}
